module.exports = __webpack_public_path__ + "img/lifeplus-logo.521cecba.png";